import { fetchClass } from "../plugins/fetchAuth.ts";
import { getUrls } from "./apiurls.js";

// var baseURL = "https://growth-api.ebuyings.com";//fida 

export async function APIGetUserLocations(id: any = "") {
  const { fida } = getUrls();
  const params = {
    params: {
      ...(id && { _id: id }),
      client_id: "aye9-qt1cj-abhrhzy7-m2tup-6x92kc5688",
      client_secret: "fp329-polk80s-ye04p1yy-45hx874z06",
    },
  };
  console.log("Thanks stores", fida);
  return fetchClass(
    `${fida}/api/getUserLocations`,
    {
      method: "GET",
      ...params,
    },
    {},
    false
  );
}